import PostCard from './PostCard';
import '../styles/posts.scss';

export default function PopularReels({ popularReelsData }) {
  if (!popularReelsData || popularReelsData?.length === 0) {
    return null;
  }
  return (
    <div className="posts-container">
      <h2 className="posts-title">Popular Reels</h2>
      <div className="demographics-card post-cards-container">
        {popularReelsData?.slice(0, 3)?.map((data, index) => (
          <PostCard
            key={index}
            image={data.thumbnail}
            link={data.link}
            description={data.text}
            likesCount={data.stat.likes}
            commentsCount={data.stat.comments}
            postedOn={data.created}
          />
        ))}
      </div>
    </div>
  );
}
